import { i18n } from '@/i18n';
import enUS from './locales/en-US';
import zhCN from './locales/zh-CN';
import zhTW from './locales/zh-TW';
import jaJP from './locales/ja-JP';

// 注意：项目使用的语言代码是 cn/en/jp/tw，不是标准的 zh-CN/en-US/ja-JP/zh-TW
i18n.global.mergeLocaleMessage('en', enUS);
i18n.global.mergeLocaleMessage('cn', zhCN);
i18n.global.mergeLocaleMessage('tw', zhTW);
i18n.global.mergeLocaleMessage('jp', jaJP);
